import React from 'react';
import  {Link}  from 'react-router-dom';
import './novocliente.css';

function NovoCliente(){
    return <div className="d-flex align-items-center text-center form-container">
      <form className="form-signin">
        <h1 className="h3 mb-3 fw-normal">Tornando-se Parceiro</h1>

        <div className="form-floating">
          <input type="email" className="form-control" id="floatingInput" placeholder="E-mail" />
          <label for="floatingInput">E-mail</label>
        </div>
        <div className="form-floating">
          <input type="password" className="form-control" id="floatingPassword" placeholder="Senha" />
          <label for="floatingPassword">Senha</label>
        </div>
        
        <button className="w-100 btn btn-lg btn-primary" type="submit">Salvar</button>

        <div className="login-links mt-5">              
            <Link to="/app" className="mx-3">Já sou parceiro</Link>  
        </div>

        <p className="mt-5 mb-3 text-muted">&copy; Desenvolvido por iSolution</p>
      </form>
    </div>;
  }

export default NovoCliente;